import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { LocationSelector } from '../../dashboard/location-component';
import { DateRangePickerComponent } from '../../dashboard/date-range-component';
import { GuestsRoomsSelector } from '../../dashboard/guest-room-component';
import { useHistory } from 'react-router-dom';
import cross from '@assets/images/gallery/cross.svg';
import { useSelector } from 'react-redux';
import { ILoginState } from '@share/store/slices';
import { BlueButton } from '@share/components';
import { UpdateSvg } from '@share/assets';
import { FormattedMessage, useIntl } from 'react-intl';
import "./style.scss";
import { HotelDatePicker } from '../../dashboard/date-range-component/hotel-date-picker';
import { isEmpty } from 'lodash';
interface Room {
  adultCount: number;
  kidsAges: number[];
}

interface HotelImage {
  src: string;
  alt: string;
}
interface Hotel {
  hotelId: number;
  displayName: string;
  starRating: number;
  countryCode: string;
  zipCode: string;
  originalPrice?: number;
  discountedPrice?: number;
  totalPrice?: number;
  refundable?: boolean;
  images?: HotelImage[];
  currency: string;
}

interface IMapStateToProps {
  loginStore: ILoginState;
}

const TopNav = ({ location, checkInDate, checkOutDate, rooms, setPageNumber }: any) => {
  const login = useSelector((state: IMapStateToProps) => state.loginStore);
  const { account } = login;
  const leadTime = account?.leadTime;
  const intl = useIntl();
  const color: any = account?.searchIconsColor;
  const styleColor = !isEmpty(color) ? { color } : {};
  const checkIn = checkInDate || '';
  const checkOut = checkOutDate || '';
  const countryName = location?.name || '';
  const room = rooms || [];
  const monthMap = {
    Jan: 'Jan ',
    Feb: 'Feb ',
    Mar: 'Mar ',
    Apr: 'Apr ',
    May: 'May ',
    Jun: 'Jun ',
    Jul: 'Jul ',
    Aug: 'Aug ',
    Sep: 'Sept ',
    Oct: 'Oct ',
    Nov: 'Nov ',
    Dec: 'Dec ',
  };
  const history = useHistory();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [disable, setDisable] = useState<boolean>(true);
  const [updatelocation, setUpdateLocation] = useState<string>(location);
  const [isLocationSelectorVisible, setIsLocationSelectorVisible] = useState<boolean>(false);
  const [updateCheckIn, setUpdateCheckIn] = useState<string>(checkIn);
  const [updateCheckOut, setUpdateSetCheckOut] = useState<string>(checkOut);
  const [isDateVisible, setIsDateVisible] = useState<boolean>(false);
  const [updateRooms, setupdateRooms] = useState<Room[]>(room);
  const [isRoomsVisible, setIsRoomsVisible] = useState<boolean>(false);
  const [isLocationSelect, setIsLocationSelect] = useState<boolean>(false);
  const [isDateSearch, setIsDateSearch] = useState<boolean>(false);
  const [isDateSelect, setIsDateSelect] = useState<boolean>(false);
  const [isRoomSelect, setIsRoomSelect] = useState<boolean>(false);
  const payload = {
    hotelsRequest: {
      residency: 'US',
      locationCode: '657822',
      location: updatelocation || [],
      checkIn: updateCheckIn || [],
      checkOut: updateCheckOut || [],
      rooms: updateRooms || [],
    },
    filter: {
      distanceInMiles: 10,
      exactSearch: true,
    },
    sortBy: 'BiggestSavingsPercentage',
    pageNumber: 1,
    pageSize: 10,
    quick: false,
    searchHomes: 'All',
    currency: 'USD',
  };

  const handleSubmit = () => {
    setIsDateSearch(false);
    if (setPageNumber) {
      setPageNumber(1);
    }
    setIsLoading(true);
    const dates = {
      checkIn: payload.hotelsRequest.checkIn,
      checkOut: payload.hotelsRequest.checkOut,
    };

    try {
      history.replace(
        `/${login.account.name}/search?dates=${btoa(JSON.stringify(dates))}&location=${btoa(
          JSON.stringify(payload.hotelsRequest.location),
        )}&rooms=${btoa(JSON.stringify(payload.hotelsRequest.rooms))}`,
      );
      setTimeout(() => {
        setIsLocationSelect(false);
        setIsDateSelect(false);
        setIsRoomSelect(false)
      }, 3000);
    } catch (error) {
      console.error('Navigation failed:', error);
      setIsLocationSelect(false);
      setIsDateSelect(false);
      setIsRoomSelect(false)
    } finally {
      setTimeout(() => {
        setIsLoading(false);
        setIsLocationSelect(false);
        setIsDateSelect(false);
        setIsRoomSelect(false)
      }, 3000);
    }
  };

  const getCustomMonthAbbreviation = (month: any) => monthMap[month];

  const handleLocationSelect = (selectedLocation: string) => {
    setDisable(false);
    setUpdateLocation(selectedLocation);
    setIsLocationSelect(true);
  };

  const handleSearchChange = (searchInput: string) => {
    setDisable(false);
    setUpdateLocation(searchInput);
  };

  const toggleLocationSelector = () => {
    setIsLocationSelectorVisible(!isLocationSelectorVisible);
  };
  const toggleDateSelector = () => {
    setIsDateVisible(!isDateVisible);
  };
  const toggleRoomSelector = () => {
    setIsRoomsVisible(!isRoomsVisible);
  };

  const handleDateChange = (newCheckIn: string, newCheckOut: string) => {  
    setDisable(false);
    setUpdateCheckIn(newCheckIn);
    setUpdateSetCheckOut(newCheckOut);
  
    const checkInDate = new Date(newCheckIn).toDateString();
    const checkOutDate = new Date(newCheckOut).toDateString();
  
    if (newCheckIn && newCheckOut && checkInDate !== checkOutDate) {
      setIsDateSelect(true);
    } else {
      setIsDateSelect(false);
    }
  };
  

  useEffect(() => {
    if(isLocationSelect || (isDateSelect && isDateSearch) || isRoomSelect ) {
      handleSubmit();
    }
  }, [isLocationSelect, isDateSelect, isRoomSelect, isDateSearch]);

  return (
    <section className="pt-4 topNav hotelLocation">
      <div className="container">
        <div className="row g-0">
          
          <div className="col-lg-4 col-lg-4 h-full position-relative row-gutter border-right">
            <div
              className="hotelLocation_wrap"
            >
              {isLocationSelectorVisible && (
                <div className="end-0 pe-3 pt-1 top-0 position-absolute z-2">
                  <img
                    src={cross}
                    width={10}
                    onClick={toggleLocationSelector}
                    className="cursor-pointer"
                    alt="Close"
                  />
                </div>
              )}
              <div
                className={`${isLocationSelectorVisible
                    ? 'w-100 topNav-page'
                    : 'd-flex justify-content-start  align-items-center btn-bi-color w-100'
                  }`}
              >
                {isLocationSelectorVisible ? (
                  ''
                ) : (
                  <div className="hotelLocation_left" style={styleColor}>
                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="location-dot" className="svg-inline--fa fa-location-dot " role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"></path></svg>
                  </div>
                )}
                <div className={`${!isLocationSelectorVisible && 'info hotelTitle'}`} >
                  <span className="hotelLocation_right_label form-control-border m-0 form-label">{isLocationSelectorVisible ? '' : (intl.formatMessage({ id: 'search.destinationLabel' }))}</span>
                  {isLocationSelectorVisible ? (
                    <div className="mt-0">
                      <LocationSelector
                        onLocationSelect={handleLocationSelect}
                        searchTerm={updatelocation}
                        onSearchChange={handleSearchChange}
                        locationValid={true}
                        showLocationHistory={false}
                      />
                    </div>
                  ) : (
                    <h6 className='text-truncate' onClick={toggleLocationSelector}>
                      {countryName}
                    </h6>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 h-full position-relative row-gutter border-right">
            <div
              className="hotelLocation_wrap topnavDate "
            >
              {isDateVisible && (
                <div className="end-0 pe-3 pt-1 top-0 position-absolute z-2">
                  <img
                    src={cross}
                    width={10}
                    onClick={toggleDateSelector}
                    className="cursor-pointer"
                    alt="Close"
                  />
                </div>
              )}
              <div
                className={`${isDateVisible ? 'w-100 topNav-page' : 'd-flex justify-content-start align-items-center btn-bi-color w-100'
                  }`}
              >
                {isDateVisible ? (
                  ''
                ) : (
                  <div className="hotelLocation_left" style={styleColor}>
                    <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="calendar-days" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-calendar-days "><path fill="currentColor" d="M128 0c17.7 0 32 14.3 32 32V64H288V32c0-17.7 14.3-32 32-32s32 14.3 32 32V64h48c26.5 0 48 21.5 48 48v48H0V112C0 85.5 21.5 64 48 64H96V32c0-17.7 14.3-32 32-32zM0 192H448V464c0 26.5-21.5 48-48 48H48c-26.5 0-48-21.5-48-48V192zm64 80v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm128 0v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H208c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V272c0-8.8-7.2-16-16-16H336zM64 400v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H80c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H208zm112 16v32c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16V400c0-8.8-7.2-16-16-16H336c-8.8 0-16 7.2-16 16z"></path></svg>
                  </div>
                )}
                <div className={`${!isDateVisible && 'info'}`}>
                  <span className='hotelLocation_right_label form-control-border m-0 form-label'>{isDateVisible ? '' : (intl.formatMessage({ id: 'dates' }))}</span>
                  
                  {isDateVisible ? (
                  <HotelDatePicker 
                      checkIn={updateCheckIn}
                      checkOut={updateCheckOut}
                      onDateChange={handleDateChange}
                      validate={true}
                      isDateValid={true}
                      leadTime={leadTime}
                      setIsDateSearch={setIsDateSearch}
                      isDateSearch={isDateSearch}
                  />
                  ) : (
                    <h6 onClick={toggleDateSelector}>
                      {getCustomMonthAbbreviation(moment(checkIn).format('MMM'))}
                      {moment(checkIn).format('DD')} -{' '}
                      {getCustomMonthAbbreviation(moment(checkOut).format('MMM'))}
                      {moment(checkOut).format('DD')}
                    </h6>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-4 row-gutter">
            <div
              className="hotelLocation_wrap rounded-start-lg-0"
            >
              {isRoomsVisible && (
                <div className="end-0 pe-3 pt-1 top-0 position-absolute z-2">
                  <img
                    src={cross}
                    width={10}
                    onClick={toggleRoomSelector}
                    className="cursor-pointer z-1"
                    alt="Close"
                  />
                </div>
              )}
              <div
                className={`${isRoomsVisible ? 'w-100 topNav-page' : 'd-flex justify-content-start align-items-center mt-1 btn-bi-color w-100'
                  }`}
              >
                {isRoomsVisible ? (
                  ''
                ) : (
                  <div className="hotelLocation_left" style={styleColor}>
                    <i className="bi bi-people fa-fw"></i>
                  </div>
                )}
                <div className={`${!isRoomsVisible && 'info'}`}>
                  <span className='hotelLocation_right_label form-control-border m-0 form-label'>{isRoomsVisible ? '' : (intl.formatMessage({ id: 'search.travellers' }))}</span>
                  {isRoomsVisible ? (
                    <GuestsRoomsSelector
                      rooms={updateRooms}
                      setRooms={setupdateRooms}
                      setDisable={setDisable}
                      setIsRoomSelect={setIsRoomSelect}
                      isLoading={isRoomSelect}
                    />
                  ) : <>
                    <h6 onClick={toggleRoomSelector}>
                      {`${rooms?.reduce((acc, room) => acc + room.adultsCount, 0)} Guests, ${rooms?.length
                        } Rooms, ${rooms?.reduce(
                          (totalKids, room) => totalKids + room.kidsAges?.length,
                          0,
                        )} Kids`}
                    </h6>
                      {/* <h6 className="mb-1 mt-1" onClick={toggleRoomSelector}>
                        {`${rooms?.reduce((acc, room) => acc + room.adultsCount, 0)} Guests, 
                          ${rooms?.length} Rooms, 
                          ${rooms?.reduce((totalKids, room) => totalKids + (room.kids?.length || 0), 0)} Kids`}
                      </h6> */}

                    </>}
                </div>
              </div>
            </div>
          </div>
          <div className="update-button-top-nav-container row-gutter">
            {/* <BlueButton className="search-button update-button-top-nav p-2 commonBlueBtn"
              onClick={handleSubmit}
              // disabled={disable || !(isDateVisible || isLocationSelectorVisible || isRoomsVisible) ? true : false}
            >
              <UpdateSvg />
              <span className='ms-1'><FormattedMessage id={'update.search.your.hotel'} /></span>
            </BlueButton> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TopNav;
